import { styled } from "styled-components";

export const ProfilePageTitle = styled.div`
  font-size: 32px;
  line-height: 150px;
`;
